import { useEffect } from "react";
import "../reportDashboard.scss";
import SectionTabs from "./SectionTabs";
import DateRangeFilter from "./DateRangeFilter";
import { applyAccentColor } from "../utils/accentTheme";

const DashboardShell = ({ clientName, accentColor, sections, dateRange, onDateRangeChange, refetching, onSectionChange }) => {
  useEffect(() => {
    applyAccentColor(accentColor);
  }, [accentColor]);

  // Phase 1 UI fix: the date-range filter used to live beside the client name
  // in rdShell__header. The v26 mockup instead gives it a dedicated full-width
  // bar directly under the section tab strip (.datefilter-bar), so it's built
  // here and passed to SectionTabs as `toolbar`, which renders it right after
  // </Tabs> and before the panels — same guard as before (both current callers,
  // the admin and public pages, always pass dateRange/onDateRangeChange, but a
  // caller that doesn't still gets a shell with no date bar rather than a
  // broken one).
  const dateToolbar = dateRange && onDateRangeChange && (
    <div className="rdDateBar">
      <span className="rdDateBar__label">Date Range</span>
      <DateRangeFilter value={dateRange} onChange={onDateRangeChange} />
      {refetching && (
        <span className="rdShell__updating rdDateBar__updating">Updating…</span>
      )}
    </div>
  );

  return (
    <div className="rdShell">
      <div className="rdShell__header">
        <h1 className="rdShell__title">{clientName}</h1>
      </div>
      <div className="rdShell__body">
        <SectionTabs onSectionChange={onSectionChange} toolbar={dateToolbar}>
          {sections}
        </SectionTabs>
      </div>
    </div>
  );
};

export default DashboardShell;
